import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=24949937&scoped=true&"
import script from "./Warning.vue?vue&type=script&lang=ts&"
export * from "./Warning.vue?vue&type=script&lang=ts&"
import style0 from "./Warning.vue?vue&type=style&index=0&id=24949937&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24949937",
  null
  
)

export default component.exports